import { Divider, Grid, Tooltip, Typography } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CloseIcon from "@material-ui/icons/Close";
import EditIcon from "@material-ui/icons/Edit";
import { useHistory } from "react-router-dom";
import LabelsContext from "../../../../lang/LabelsContext";
import { getTicketStatus, parseDate } from "../../../../utils/Utils";
import { useStyles } from "../../tickets/TicketStyle";

export default function TicketCard(props: any) {
  const { name, status, id, date, ticketDelete, type } = props;
  const classes = useStyles();
  const { Labels } = LabelsContext();

  const history = useHistory();
  return (
    <div>
      <Card className={classes.root}>
        <CardContent>
          <Typography variant="body2" color="textSecondary" component="p">
            {type}
          </Typography>
          <Tooltip title={<h3>{name}</h3>}>
            <Typography gutterBottom variant="body2" component="h2">
              {name.length > 50 ? name.substring(0, 60) + "..." : name}
            </Typography>
          </Tooltip>

          <Divider />
          <Grid
            container
            justifyContent={date ? "space-between" : "flex-end"}
            direction="row"
            className={classes.marginTop}
          >
            {date && (
              <Grid item direction="column" justifyContent="flex-end" alignItems="flex-end">
                <Typography variant="body2" color="textSecondary" component="p">
                  {"Date"}
                </Typography>
                <Typography variant="body2" component="p">
                  {parseDate(date)}
                </Typography>
              </Grid>
            )}
            <Grid item direction="column" justifyContent="flex-end" alignItems="flex-end">
              <Typography variant="body2" color="textSecondary" component="p">
                {Labels.STATUS}
              </Typography>
              <Typography variant="body2" component="p">
                {getTicketStatus(status, Labels)}
              </Typography>
            </Grid>
          </Grid>
        </CardContent>
        <CardActions>
          <Grid container justifyContent="flex-end" alignItems="flex-end">
            <Button
              startIcon={<EditIcon />}
              size="small"
              color="primary"
              variant="contained"
              className={classes.button}
              onClick={(e) => {
                history.push("/tickets/editTicket/" + id);
              }}
            >
              {Labels.VIEW}
            </Button>
            <Button
              startIcon={<CloseIcon />}
              size="small"
              variant="contained"
              className={classes.deleteButton}
              onClick={() => {
                ticketDelete(id);
              }}
            >
              {Labels.CLOSE}
            </Button>
          </Grid>
        </CardActions>
      </Card>
    </div>
  );
}
